import React from 'react';
import { string, bool } from 'prop-types';

import Box from '../atoms/Box';
import Card from '../atoms/Card';
import { emitEvent, EVENTS } from '../../utils/analytics';
import { useTranslate } from '../../translate/I18n';
import { assetize } from '../../utils/pureUtils';
import SanitizedHTML from '../elements/SanitizedHTML';

const PartnerForPublicUser = ({ camelCaseName, logoFilePath, description, link, noFollow, ctaLabel }) => {
  const { t } = useTranslate(['common']);
  const trackClick = () => {
    const event = EVENTS.PARTNER[camelCaseName.toUpperCase()];
    if (event) emitEvent(event.INFO);
  };

  return (
    <Card
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-between"
      mb={4}
      minHeight="400px"
      p={3}
      data-cy={`${camelCaseName}-card`}>
      <Box>
        <Box mb={2} textAlign="center">
          <a
            onClick={trackClick}
            href={`${link}?utm_source=beelance&utm_medium=referral&utm_content=logo`}
            target="_blank"
            rel="noopener noreferrer">
            <img
              alt={camelCaseName}
              title={camelCaseName}
              src={assetize(`/${logoFilePath}`)}
              width="100%"
              style={{ maxWidth: '250px' }}
              data-cy={`${camelCaseName}-logo`}
            />
          </a>
        </Box>
        <Box mb={2}>
          <SanitizedHTML content={description} />
        </Box>
      </Box>
      <a
        onClick={trackClick}
        className="link"
        href={`${link}?utm_source=beelance&utm_medium=referral&utm_content=moreInfo`}
        // eslint-disable-next-line react/jsx-no-target-blank
        target="_blank"
        rel={`noopener noreferrer ${noFollow ? 'nofollow' : ''}`}
        data-cy={`${camelCaseName}-cta`}>
        {ctaLabel || t('common:moreInformation')}
      </a>
    </Card>
  );
};

PartnerForPublicUser.propTypes = {
  camelCaseName: string,
  logoFilePath: string,
  description: string,
  stage: string,
  link: string,
  ctaLabel: string,
  noFollow: bool
};

export default PartnerForPublicUser;
